/**
 * Короткий салют на canvas — награда за верно решённое задание.
 * Без библиотек: несколько десятков частиц, полторы секунды, потом canvas очищается.
 */

type Particle = {
  x: number;
  y: number;
  vx: number;
  vy: number;
  size: number;
  color: string;
  spin: number;
  angle: number;
};

const COLORS = ["#f43f5e", "#f59e0b", "#22c55e", "#38bdf8", "#a855f7", "#facc15"];
const DURATION_MS = 1_600;
const GRAVITY = 0.28;

const running = new WeakSet<HTMLCanvasElement>();

export function burstConfetti(canvas: HTMLCanvasElement, count = 90): void {
  if (running.has(canvas)) return;
  const w = canvas.clientWidth || Number(canvas.getAttribute("width")) || 400;
  const h = canvas.clientHeight || Number(canvas.getAttribute("height")) || 300;
  if (w <= 0 || h <= 0) return;

  const dpr = Math.min(2, window.devicePixelRatio || 1);
  canvas.width = Math.round(w * dpr);
  canvas.height = Math.round(h * dpr);
  const ctx = canvas.getContext("2d");
  if (!ctx) return;
  ctx.scale(dpr, dpr);

  const particles: Particle[] = [];
  for (let i = 0; i < count; i++) {
    const fromLeft = i % 2 === 0;
    particles.push({
      x: fromLeft ? w * 0.08 : w * 0.92,
      y: h * 0.72,
      vx: (fromLeft ? 1 : -1) * (2 + Math.random() * 5),
      vy: -(6 + Math.random() * 6),
      size: 4 + Math.random() * 5,
      color: COLORS[i % COLORS.length],
      spin: (Math.random() - 0.5) * 0.35,
      angle: Math.random() * Math.PI,
    });
  }

  running.add(canvas);
  const start = performance.now();

  const frame = (now: number) => {
    const elapsed = now - start;
    ctx.clearRect(0, 0, w, h);
    if (elapsed > DURATION_MS || !canvas.isConnected) {
      running.delete(canvas);
      return;
    }
    const fade = Math.max(0, 1 - elapsed / DURATION_MS);
    ctx.globalAlpha = Math.min(1, fade * 1.6);
    for (const p of particles) {
      p.vy += GRAVITY;
      p.vx *= 0.995;
      p.x += p.vx;
      p.y += p.vy;
      p.angle += p.spin;
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.angle);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
      ctx.restore();
    }
    ctx.globalAlpha = 1;
    requestAnimationFrame(frame);
  };

  requestAnimationFrame(frame);
}
